import {useEffect, useState} from '@wordpress/element';

export const ImageLoader = ({
                                src,
                                skeletonClassName = '',
                                errorFallback = null,
                                ...imgProps
                            }) => {
    const [status, setStatus] = useState(() => (src ? 'loading' : 'idle'));
    const [prevSrc, setPrevSrc] = useState(src);
    // idle | loading | loaded | error

    if (src !== prevSrc) {
        setPrevSrc(src);
        setStatus(src ? 'loading' : 'idle');
    }

    useEffect(() => {
        if (!src) {
            return;
        }

        let cancelled = false;
        setStatus('loading');

        const pre = new window.Image();
        pre.decoding = 'async';

        const finalizeLoaded = () => {
            if (!cancelled) setStatus('loaded');
        };

        pre.onload = async () => {
            try {
                // decode() ensures the image is ready to paint, reducing alt-text flashes
                if (pre.decode) await pre.decode();
            } catch (e) {
                // decode can fail even when the image loads; still allow render
            }
            finalizeLoaded();
        };

        pre.onerror = () => {
            if (!cancelled) setStatus('error');
        };

        pre.src = src;

        return () => {
            cancelled = true;
        };
    }, [src]);

    if (status === 'loaded') {
        return (
            <img
                src={src}
                {...imgProps}
                loading="eager"
                draggable={false}
                onError={(e) => {
                    setStatus('error');
                    if (imgProps.onError) imgProps.onError(e);
                }}
            />
        );
    }

    if (status === 'error') {
        return (
            errorFallback ?? (
                <div className={`bg-base-200 flex items-center justify-center text-xs text-base-content/50 ${imgProps.className || ''}`}>
                    Image unavailable
                </div>
            )
        );
    }

    return (
        <div className={`skeleton ${imgProps.className || ''} ${skeletonClassName}`} />
    );
};